import React from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';
import Modal from '../components/widgets/Modal';
import Snackbox from '../components/widgets/Snackbox';
import {checkAuth, quitAuth, clearPatient} from '../actions';
import history from '../history';


class Auth extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal : false,
            modalMsg :"",
            showSnackbox : false
        };
        this.onSignInClick = this.onSignInClick.bind(this);
        this.onSignOutClick = this.onSignOutClick.bind(this);
    
    };

    componentDidMount() {
     
    }

    onSignInClick() {
        this.setState({showModal : true, modalMsg: ""});
        
    }

    onSignOutClick() {
        this.props.quitAuth();
        this.setState({ showModal : false, modalMsg: ""});   
        this.props.clearPatient();
        history.push('/');
        
    }

    renderAuthBox() {


        const AuthForm = () => {
            const required = value =>(value ? undefined : 'Required');
            const handleSubmit = (formValues) => {
            
                this.setState({modalMsg:"Checking ..."});
                const form = formValues;
                this.props.checkAuth(form)
                .then(() => {
                    if (this.props.auth[0] === true) {
                        this.setState({modalMsg:"Login success. Please wait while loading data ... ", showModal : false, showSnackbox:true})
                    } else {
                        this.setState({showModal : true, modalMsg:"Invalid username and/or password"});
                    }
                });
            }

            return (
                <Form 
                    onSubmit = {handleSubmit} 
                    render = {({ handleSubmit, pristine, submitting }) => {
                        return   (
                            <form onSubmit={handleSubmit} >
                                <Field name='username' component='input' validate={required} placeholder='type in username here'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Username</label>
                                            <input {...input} autocomplete='off' placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <p></p>
                                <Field name='password' component='input' validate={required} placeholder='type in password here'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Password</label>
                                            <input {...input} type='password' autocomplete='off' placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                      
                                <div className='modalButton'>
                                    <button type='submit' disabled={submitting || pristine} style={{width:'114px'}} className='btnew'>Sign in</button>
                                    <button onClick={() => this.setState({showModal: false})}  style={{width:'114px'}} className='btdel'>Cancel</button>
                                </div>

                                <p></p>
                                <div style={{color:'red'}}>{this.state.modalMsg}</div>
                            </form>
                        )
                    }}
                />
            )
        }
    
        return (
            <Modal 
            height='240px'
            width='240px'
            open={this.state.showModal} 
            title='User Login'
            content={AuthForm()}
            onDismiss={() => this.setState({showModal: false})}
            />
        )
    }

    renderAuthButton() {
        if (this.props.auth[0] === undefined) {
            return (
                <button onClick={this.onSignInClick} className='btSignIn'>
                    Sign in
                </button>
            )
        }
        else if (this.props.auth[0] === false) {
            return (
                <button onClick={this.onSignInClick} className='btSignIn'>
                    Sign in
                </button>
            );
        } else {
            return (
                <button onClick={this.onSignOutClick} className='btSignOut'>
                    Sign Out
                </button>
            );
        }
    }

    renderSnackBox() {
        return (
            <Snackbox open={this.state.showSnackbox} message="Sign in successful !"/>
        )
    }

    render() {
        return (
            <div>
            <div>{this.renderAuthButton()}</div>
            {this.renderAuthBox()} 
            {this.renderSnackBox()}
            </div>
           
        )
    };
};


const mapStateToProps = (state) => {
    return {
        auth: Object.values(state.auth),
        signin : state.signin
    };
};

export default connect(mapStateToProps, {checkAuth, quitAuth, clearPatient})(Auth);